// extracted by css-extract-rspack-plugin
export default {"container":"GridPageLayout_mobile_container__NNR3F","island":"GridPageLayout_mobile_island___MOqA","islandContainer":"GridPageLayout_mobile_islandContainer__eI0a9"};